import Vue from 'vue'
import Vuex from 'vuex'
import { getUserInfo, refreshToken as refreshTokenApi, logout as logoutApi, loginByBackendAuth } from '@/api/auth'

Vue.use(Vuex)

const TOKEN_KEY = 'uav_access_token'
const REFRESH_KEY = 'uav_refresh_token'

export default new Vuex.Store({
  state: {
    token: localStorage.getItem(TOKEN_KEY) || '',
    refreshToken: localStorage.getItem(REFRESH_KEY) || '',
    userInfo: null
  },

  getters: {
    token: state => state.token,
    refreshToken: state => state.refreshToken,
    userInfo: state => state.userInfo,
    isLoggedIn: state => !!state.token
  },

  mutations: {
    SET_TOKEN(state, { token, refreshToken }) {
      state.token = token
      state.refreshToken = refreshToken
      localStorage.setItem(TOKEN_KEY, token)
      localStorage.setItem(REFRESH_KEY, refreshToken)
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    CLEAR_AUTH(state) {
      state.token = ''
      state.refreshToken = ''
      state.userInfo = null
      localStorage.removeItem(TOKEN_KEY)
      localStorage.removeItem(REFRESH_KEY)
    }
  },

  actions: {
    // 登录成功后设置 Token（企微回调页调用）
    setToken({ commit }, { token, refreshToken }) {
      commit('SET_TOKEN', { token, refreshToken })
    },

    async backendLogin({ commit, dispatch }) {
      const tokenInfo = await loginByBackendAuth()
      const accessToken = tokenInfo.accessToken || tokenInfo.token
      const refreshToken = tokenInfo.refreshToken || ''
      if (!accessToken) {
        throw new Error('后端未返回登录 token')
      }
      commit('SET_TOKEN', { token: accessToken, refreshToken })
      await dispatch('fetchUserInfo')
      return tokenInfo
    },

    // 开发环境登录（绕过企微）
    devLogin({ commit }) {
      const mockToken = 'dev-access-token-' + Date.now()
      const mockRefreshToken = 'dev-refresh-token-' + Date.now()
      commit('SET_TOKEN', { token: mockToken, refreshToken: mockRefreshToken })

      const mockUserInfo = {
        userId: 'dev_user_001',
        name: '开发测试用户',
        avatar: '',
        mobileNumber: '13369159892',
        department: '研发部',
        roles: ['super_admin'],
        dataPermission: {}
      }
      commit('SET_USER_INFO', mockUserInfo)
      localStorage.setItem('uav_dev_mobile', mockUserInfo.mobileNumber)
      return Promise.resolve(mockUserInfo)
    },

    // 获取当前用户信息
    async fetchUserInfo({ commit }) {
      const data = await getUserInfo()
      commit('SET_USER_INFO', data)
      return data
    },

    // 刷新 token
    async refreshToken({ state, commit }) {
      const res = await refreshTokenApi(state.refreshToken)
      commit('SET_TOKEN', {
        token: res.accessToken,
        refreshToken: res.refreshToken
      })
      return res
    },

    // 退出登录
    async logout({ commit }) {
      try {
        await logoutApi()
      } catch (e) {
        // ignore
      }
      commit('CLEAR_AUTH')
    }
  }
})
